(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["facets-wyper"] && !Shopify.designMode) return;
  try {
    (() => {
 const init = () => document.querySelectorAll('[data-facet-popovers]').forEach(form => {
  if(form.dataset.popoversReady) return;
  form.dataset.popoversReady = 'true';
  const groups = [...form.querySelectorAll('details.wyper-filter')];
  groups.forEach(group => {
   let badge=group.querySelector('[data-facet-count]');
   if(!badge){badge=document.createElement('em');badge.dataset.facetCount='';group.querySelector('.wyper-filter__meta').prepend(badge);}
   const updateCount=()=>{
    const checks=[...group.querySelectorAll('input[type=checkbox],input[type=radio]')];
    const numbers=[...group.querySelectorAll('input[type=number]')];
    const count=checks.filter(input=>input.checked).length+(numbers.some(input=>input.value!=='')?1:0);
    badge.textContent=String(count);badge.hidden=count===0;
    badge.setAttribute('aria-label',count+' opciones seleccionadas');
    group.toggleAttribute('data-active',count>0);
   };
   const prices=[...group.querySelectorAll('input[type=number]')];
   const sliders=[...group.querySelectorAll('input[type=range]')];
   if(prices.length===2){
    const validate=()=>{prices[1].setCustomValidity(prices[0].value!==''&&prices[1].value!==''&&Number(prices[0].value)>Number(prices[1].value)?'El precio máximo debe ser mayor o igual que el mínimo.':'');};
    prices.forEach((input,i)=>input.addEventListener('input',()=>{validate();if(sliders[i])sliders[i].value=input.value|| (i===0?0:sliders[i].max);}));
    sliders.forEach((input,i)=>input.addEventListener('input',()=>{
     if(i===0)input.value=Math.min(Number(input.value),Number(sliders[1].value));
     else input.value=Math.max(Number(input.value),Number(sliders[0].value));
     prices[i].value=input.value;validate();updateCount();
    }));
   }
   updateCount();
   group.addEventListener('change',updateCount);
   group.addEventListener('input',updateCount);
   group.addEventListener('toggle', () => {
    if(!group.open) return;
    groups.forEach(other => {if(other !== group) other.open = false;});
    const panel=group.querySelector('.wyper-filter__body');
    panel.style.left='';
    if(innerWidth >= 900 && panel.getBoundingClientRect().right > innerWidth-20) panel.style.left=(innerWidth-20-panel.getBoundingClientRect().right)+'px';
   });
  });
  form.addEventListener('submit', event => {
   const button=event.submitter;
   const group=button?.closest('details.wyper-filter');
   if(!group) return;
   event.preventDefault();
   if(!button.hasAttribute('data-facet-clear') && !form.reportValidity()) return;
   const url=new URL(location.href);
   url.searchParams.delete('page');
   url.searchParams.set('filter.v.availability','1');
   const inputs=[...group.querySelectorAll('input[name]')];
   new Set(inputs.map(input=>input.name)).forEach(name=>url.searchParams.delete(name));
   if(!button.hasAttribute('data-facet-clear')){
    inputs.forEach(input=>{
     if(input.disabled || ((input.type==='checkbox'||input.type==='radio')&&!input.checked) || input.value==='')return;
     url.searchParams.append(input.name,input.value);
    });
   }
   location.assign(url.href);
  });
  document.addEventListener('click',event=>{if(!form.contains(event.target))groups.forEach(g=>g.open=false);});
  form.addEventListener('keydown',event=>{if(event.key==='Escape'){const group=event.target.closest('details');if(group){group.open=false;group.querySelector('summary').focus();}}});
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
 document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

})();
